import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { TipoUsuario } from 'src/app/shared/enums/tipoUsuario';

@Component({
  selector: 'app-management-index',
  templateUrl: './management-index.component.html',
  styleUrls: ['./management-index.component.css']
})
export class ManagementIndexComponent implements OnInit {

  TipoUsuario = TipoUsuario;

  constructor(private authService : AuthService) { }

  ngOnInit() {
  }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }


}
